import { api } from '@api'
import { Scope } from '@utils'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { ScheduledMessage } from './usePaginateScheduledMessages'

const fetchScheduledMessagesByRecipientId = async (
  recipientId: string,
  groupId: string | undefined,
  { pageParam = '0', search, scope, moment }: FetchParams
): Promise<PaginatedResponse<ScheduledMessage>> => {
  const id = groupId || recipientId
  if (!id) return { data: [], metadata: { count: 0, limit: 0, page: 0 } }
  const base = groupId ? `/groups/${id}` : `/contacts/${id}`
  let url = `${base}/scheduled-messages?page=${pageParam}`
  if (search) url += `&search=${search}`
  if (scope) url += `&scope=${scope}`
  if (moment) url += `&moment=${moment}`

  const { data } = await api.get<PaginatedResponse<ScheduledMessage>>(url)
  return data
}

export const usePaginateScheduledMessagesByRecipientId = (
  recipientId: string,
  { search, scope, moment, groupId }: { search?: string, scope?: Scope, moment?: 'today' | 'week' | 'month' | 'later', groupId?: string } = {}
) => {
  const id = groupId || recipientId
  return usePaginate<ScheduledMessage>(
    `scheduled-messages-by-recipient-${id}`,
    (params) => fetchScheduledMessagesByRecipientId(recipientId, groupId, params),
    { search, scope, moment }
  )
}

